import { render, staticRenderFns } from "./Continent.vue?vue&type=template&id=c4e4fd2a&scoped=true"
import script from "./Continent.vue?vue&type=script&lang=js"
export * from "./Continent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4e4fd2a",
  null
  
)

export default component.exports